import Vue from 'vue'

/**
 * Declaração global para emitir e receber eventos.
 */
export const GlobalBus = new Vue()
